import { createPortal } from "react-dom";
import { useNavigate } from "react-router-dom";
import { usePopupStore } from "store/usePopupStore";

interface ConfirmPopProps {
    closePop?: "custom";
    handleClose?: () => void;
    goBack?: number;
    handleClick?: () => void;
}

export default function ConfirmPop({ closePop, handleClose, goBack, handleClick }: ConfirmPopProps) {
    const navigate = useNavigate();
    const { confirmPopTit, confirmPopTxt, confirmPopBtn, setConfirmPop } = usePopupStore();

    //팝업닫기
    const handleClosePop = () => {
        //팝업닫기 custom <ConfirmPop closePop="custom" handleClose={팝업닫는함수} /> 형식으로 쓰면 원하는 팝업닫는함수사용 가능
        if (closePop === "custom" && handleClose) {
            handleClose();
            setConfirmPop(false, "", "", null);
        }

        //창 이동 <ConfirmPop goBack={1}/> 형식으로 쓰면 숫자만큼 확인후 뒤로감
        if (goBack) {
            navigate(-goBack);
            setConfirmPop(false, "", "", null);
        }

        if (!goBack && !closePop) {
            setConfirmPop(false, "", "", null);
        }
    };

    return createPortal(
        <>
            <div className="w-full h-full left-0 top-0 flex justify-center items-center fixed z-[999] pointer-events-auto">
                <div className="w-full h-full left-0 top-0 absolute bg-[rgba(0,0,0,0.6)]"></div>
                <div className="relative bg-white rounded-[16px] max-w-[calc(100%-30px)] w-[480px] overflow-hidden">
                    <div className="p-[16px_20px] relative">
                        <p className="text-[24px] font-medium w-[calc(100%-24px)]">
                            <strong>{confirmPopTit}</strong>
                        </p>
                        <button
                            type="button"
                            className="absolute top-[22px] right-[20px] w-[24px] h-[24px] bg-ic_close bg-no-repeat bg-center -indent-[9999px]"
                            onClick={handleClosePop}
                        >
                            닫기버튼
                        </button>
                    </div>
                    <div className="overflow-x-hidden overflow-y-auto max-h-[80vh]">
                        <p className="p-[20px] text-center text-[20px]" dangerouslySetInnerHTML={{ __html: confirmPopTxt }}></p>
                    </div>
                    {confirmPopBtn === 1 && (
                        <button
                            type="button"
                            className="w-full text-white text-[20px] font-bold bg-[#132E47] p-[10px]"
                            onClick={handleClosePop}
                        >
                            확인
                        </button>
                    )}
                    {confirmPopBtn === 2 && (
                        <div className="flex justify-between items-center">
                            <button
                                type="button"
                                className={`text-[#132E47] text-[20px] bg-[#ddd] p-[10px] w-1/2`}
                                onClick={handleClosePop}
                            >
                                취소
                            </button>
                            <button
                                type="button"
                                className={`text-white text-[20px] font-bold p-[10px] w-1/2 bg-[#132E47]`}
                                onClick={() => {
                                    if (handleClick) {
                                        handleClick();
                                    }
                                    handleClosePop();
                                }}
                            >
                                확인
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </>,
        document.getElementById("modal-root")!,
    );
}
